import { AlignSelfType, MarginType, PaddingType } from 'common/types/styleTypes'
import {
  alignSelfCss,
  containerCss,
  marginCss,
  mobileAlignSelfCss,
  mobileMarginCss,
  mobilePaddingsCss,
  mobileTextCss,
  paddingsCss,
  textCss,
} from 'common/utils/styleUtilsNew'
import {
  SearchDropdownInterface,
  SearchItemTextInterface,
  SearchSeeMoreInterface,
} from 'src/shared/types/entities/search-interface'
import styled, { css } from 'styled-components'

export const SearchAutocompleteWrapperUi = styled.div`
  width: 100%;
`
export const SearchAutocompleteDropdownUi = styled.div<SearchDropdownInterface>`
  width: 100%;
  overflow: hidden;
  ${containerCss}
  ${marginCss}

  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
  }
`

interface SearchAutocompleteSeeMoreWrapperUiStylesInterface {
  padding?: PaddingType
  mobilePadding?: PaddingType
  alignSelf?: AlignSelfType
  mobileAlignSelf?: AlignSelfType
}

export const SearchAutocompleteSeeMoreWrapperUi = styled.div<SearchAutocompleteSeeMoreWrapperUiStylesInterface>`
  width: 100%;
  max-width: 100%;
  display: flex;

  ${paddingsCss};
  ${alignSelfCss};

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    ${mobilePaddingsCss}
    ${mobileAlignSelfCss}
  `}  
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
    ${mobileAlignSelfCss}
  }
  `

interface SearchAutocompleteSeeMoreUiStylesInterface
  extends Omit<
    SearchSeeMoreInterface,
    'padding' | 'mobilePadding' | 'alignSelf' | 'mobileAlignSelf'
  > {}

export const SearchAutocompleteSeeMoreUi = styled.button<SearchAutocompleteSeeMoreUiStylesInterface>`
  cursor: pointer;
  border: none;
  background: none;
  ${textCss};

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    ${mobileTextCss}
  `}  
  ${p => p.theme.phone} {
    ${mobileTextCss}
  }
`
